import { $, each } from '../util'

const Search = (() => {
  const init = () => {
    const searches = $('.js-search')

    each(searches, (_i, search) => {
      const input = search.querySelector('input')
      const remove = search.querySelector('.js-search-remove')

      remove.addEventListener('click', (e) => {
        input.value = ''
      })
    })
  }

  return {
    init,
  }
})()

export default Search


// WEBPACK FOOTER //
// app/javascript/scripts/components/Search.js